/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MountPrimaryContainerEntry } from '../../models/mount-primary-container-entry';
import { MountPrimaryContainerResponse } from '../../models/mount-primary-container-response';

export interface MountPrimaryContainer$Params {
  workCenterId: number;
      body: MountPrimaryContainerEntry
}

export function mountPrimaryContainer(http: HttpClient, rootUrl: string, params: MountPrimaryContainer$Params, context?: HttpContext): Observable<StrictHttpResponse<MountPrimaryContainerResponse>> {
  const rb = new RequestBuilder(rootUrl, mountPrimaryContainer.PATH, 'post');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MountPrimaryContainerResponse>;
    })
  );
}

mountPrimaryContainer.PATH = '/api/v1/PrimaryMaterial/{workCenterId}/Mount';
